(() => {
  const initSection = (section) => {
    if (!section || section.dataset.leileInitialized === 'true') return;
    section.dataset.leileInitialized = 'true';

    const media = [...section.querySelectorAll('[data-leile-media]')];
    const controls = [...section.querySelectorAll('[data-leile-gallery-go]')];
    const gallery = section.querySelector('.leile-cp__gallery');
    const mediaWindow = section.querySelector('.leile-cp__media-window');
    const thumbsTrack = section.querySelector('[data-leile-thumbs]');
    const thumbControls = [...section.querySelectorAll('[data-leile-thumb]')];
    const previousThumbButton = section.querySelector('[data-leile-thumb-previous]');
    const nextThumbButton = section.querySelector('[data-leile-thumb-next]');
    const variantDataNode = section.querySelector('[data-leile-variants]');
    const optionSelects = [...section.querySelectorAll('[data-leile-option]')];
    const variantIdInput = section.querySelector('[data-leile-variant-id]');
    const priceNode = section.querySelector('[data-leile-price]');
    const availabilityText = section.querySelector('[data-leile-availability-text]');
    const availabilityDot = section.querySelector('.leile-cp__availability-dot');
    const addButton = section.querySelector('[data-leile-add]');
    const addLabel = section.querySelector('[data-leile-add-label]');
    const quantityInput = section.querySelector('[data-leile-quantity]');
    let activeIndex = 0;
    let touchStartX = 0;
    let variants = [];

    const updateStickyGalleryPosition = () => {
      if (!gallery || !section.classList.contains('leile-cp--sticky-gallery')) return;

      if (!window.matchMedia('(min-width: 990px)').matches) {
        gallery.style.removeProperty('--leile-cp-gallery-sticky-top');
        return;
      }

      const header = document.querySelector('#shopify-section-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 80;
      const viewportGap = 20;
      const preferredTop = headerHeight + viewportGap;
      const bottomAlignedTop = window.innerHeight - gallery.getBoundingClientRect().height - viewportGap;
      const stickyTop = Math.min(preferredTop, bottomAlignedTop);

      gallery.style.setProperty('--leile-cp-gallery-sticky-top', `${Math.round(stickyTop)}px`);
    };

    try {
      variants = variantDataNode ? JSON.parse(variantDataNode.textContent) : [];
    } catch (error) {
      variants = [];
    }

    const moneyFormat = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat);
      }
      return `${(Number(cents || 0) / 100).toFixed(2)}`;
    };

    const showMedia = (index) => {
      if (!media.length) return;
      activeIndex = (index + media.length) % media.length;
      media.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      controls.forEach((control) => {
        const active = Number(control.dataset.leileGalleryGo) === activeIndex;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-current', active ? 'true' : 'false');
      });

      const activeThumb = thumbControls.find(
        (control) => Number(control.dataset.leileGalleryGo) === activeIndex
      );
      if (thumbsTrack && activeThumb) {
        const centeredLeft =
          activeThumb.offsetLeft - (thumbsTrack.clientWidth - activeThumb.offsetWidth) / 2;
        thumbsTrack.scrollTo({
          left: Math.max(0, centeredLeft),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => showMedia(Number(control.dataset.leileGalleryGo)));
    });

    previousThumbButton?.addEventListener('click', () => showMedia(activeIndex - 1));
    nextThumbButton?.addEventListener('click', () => showMedia(activeIndex + 1));

    if (mediaWindow) {
      mediaWindow.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      mediaWindow.addEventListener('touchend', (event) => {
        const delta = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) < 40) return;
        showMedia(activeIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }

    section.querySelector('[data-leile-quantity-minus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    });
    section.querySelector('[data-leile-quantity-plus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
    });

    const updateVariant = () => {
      if (!optionSelects.length || !variants.length) return;
      const selectedOptions = optionSelects.map((select) => select.value);
      const variant = variants.find((item) =>
        item.options.every((option, index) => option === selectedOptions[index])
      );
      if (!variant) return;

      variantIdInput.value = variant.id;
      const formattedPrice = moneyFormat(variant.price);
      priceNode.textContent = formattedPrice;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available
        ? `${section.dataset.addLabel || 'Add To Bag'} · ${formattedPrice}`
        : section.dataset.soldOutLabel || 'Sold out';
      availabilityText.textContent = variant.available
        ? section.dataset.inStockLabel || 'In stock and ready to order'
        : section.dataset.soldOutLabel || 'Sold out';
      if (availabilityDot) availabilityDot.hidden = !variant.available;

      if (variant.featured_media) {
        const targetIndex = media.findIndex(
          (item) => Number(item.dataset.mediaId) === Number(variant.featured_media.id)
        );
        if (targetIndex >= 0) showMedia(targetIndex);
      }
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));

    requestAnimationFrame(updateStickyGalleryPosition);
    window.addEventListener('resize', updateStickyGalleryPosition, { passive: true });

    if ('ResizeObserver' in window && gallery) {
      const galleryResizeObserver = new ResizeObserver(updateStickyGalleryPosition);
      galleryResizeObserver.observe(gallery);
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-leile-conversion-product]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
